module.exports = __webpack_public_path__ + "assets/GoldGamma.d421649258b2d12d05780c806b88f410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldGamma.png
// module id = 762
// module chunks = 0